<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt {{ RolePolicies.title }}</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col v-for="item in  displayData " :key="item.id" cols="12" md="6" class="pl-4">
        <v-checkbox v-model="item.isCheck" :label="`Cho phép ${item.name}`" hide-details class="ma-0 pa-0"></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="resetPolicies()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    RolePolicies: Object,
    selectedRole: Object,
    selectePolicy: String,
  },
  data() {
    return {
      displayData: []
    }
  },
  mounted() {
    this.initDisplayData()
  },
  computed: {
    ...mapGetters({
      role: 'auth/role',
    }),
  },
  methods: {
    initDisplayData() {
      this.displayData = this.RolePolicies.policies.map((policy) => ({
        ...policy,
        isCheck: policy.role.includes(this.selectedRole.name),
      }))
    },
    save() {
      const idPolicies = this.displayData.map(item => {
        if (item.isCheck) {
          if (!item.role.includes(this.selectedRole.name)) {
            item.role.push(this.selectedRole.name)
          }
        } else {
          const index = item.role.indexOf(this.selectedRole.name)
          if (index !== -1) {
            item.role.splice(index, 1)
          }
        }
        return item
      })

      this.$emit('updatePolicies', idPolicies)
    },
    resetPolicies() {
      this.initDisplayData()
    }
  },
  watch: {
    RolePolicies() {
      this.initDisplayData()
    },
    selectedRole() {
      this.initDisplayData()
    }
  }
}
</script>
